(function(){

(function () {

  // Same magnifier as the header, so quick view reads as "look closer"
  // rather than as a new piece of vocabulary.
  var MAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" aria-hidden="true">' +
    '<circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/></svg>';

  // ONE url per product, used by the slot thumbnail, the grid card AND the
  // lightbox. Two different urls for the same photo means two downloads, and
  // the second one is the wait the user sees. 900px covers the largest the
  // dialog ever draws; Shopify never upscales, so smaller originals come back
  // untouched and big ones arrive far faster than the raw file.
  function shot(u) {
    if (!u) return u;
    if (/[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=900';
  }
  var big = shot;

  // Locking the page removes the scrollbar, the viewport gets ~15px wider and
  // centred content slides sideways. Measure the change the lock actually
  // caused and give the width back as padding.
  function lockScroll() {
    var before = document.documentElement.clientWidth;
    document.documentElement.classList.add('lb-on');
    var pad = document.documentElement.clientWidth - before;
    if (pad > 0) document.documentElement.style.paddingRight = pad + 'px';
  }
  function unlockScroll() {
    document.documentElement.style.paddingRight = '';
    document.documentElement.classList.remove('lb-on');
  }
  var slots = window.C2C_SLOTS || [];
  var picked = {};

  /* ------------------------------------------------------------------ parts
     Each step reads its own collection a page at a time through Shopify's Section Rendering API
     (sections/build-items.liquid), so Shopify applies the filters, the order and the paging. A step can hold
     a thousand decks without the page ever carrying more than one page of them. ITEMS keeps every part
     loaded so far by variant id, for quick view and the summary. */
  var PAGE_SIZE = 48;
  // Four rows of parts, then "Show more" adds four more (Colin, 23 Oct 2026). Rows, not a number of parts, so
  // it is four rows whether the grid is two columns wide on a phone or six on a desktop. Parts beyond the rows
  // shown stay loaded but hidden; "Show more" reads the next page from Shopify only when the rows need it.
  var ROWS = 4;
  var ITEMS = {};
  var STEP = {};
  var HIDE_FILTERS = { 'filter.v.availability': 1, 'filter.p.tag': 1, 'filter.v.option.size': 1, 'filter.p.product_type': 1 };
  function step(key) {
    return STEP[key] || (STEP[key] = { picks: {}, sort: '', maxPrice: '', items: [], page: 0, pages: 1,
                                       count: null, facets: [], loading: false, error: false, seq: 0, rows: ROWS });
  }
  function slotOf(key) { return slots.filter(function (x) { return x.key === key; })[0]; }

  function query(st, page) {
    // In stock only: the type collections also list his sold-out items now (at the end, marked Sold out), and a
    // board can only be built from parts there are. sections/main-build.liquid preloads this same address.
    var q = ['section_id=build-items', 'page=' + page, 'filter.v.availability=1'];
    if (st.sort) q.push('sort_by=' + encodeURIComponent(st.sort));
    if (st.maxPrice) q.push('filter.v.price.lte=' + encodeURIComponent(st.maxPrice));
    Object.keys(st.picks).forEach(function (param) {
      st.picks[param].forEach(function (v) { q.push(encodeURIComponent(param) + '=' + encodeURIComponent(v)); });
    });
    return q.join('&');
  }

  function load(key, more) {
    var s = slotOf(key), st = step(key);
    if (!s || !s.collection) return;
    var page = more ? st.page + 1 : 1, seq = ++st.seq;
    st.loading = true; st.error = false;
    if (!more) { st.items = []; st.page = 0; st.rows = ROWS; }   // new filters or order: back to four rows
    if (key === active) renderPicker();
    fetch('/collections/' + s.collection + '?' + query(st, page))   // plain, so it can reuse the page's preload
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        if (seq !== st.seq) return;                     // a newer request for this step is on its way
        var m = html.match(/<script type="application\/json" data-build-items>([\s\S]*?)<\/script>/);
        if (!m) throw new Error('no parts in the answer');
        var d = JSON.parse(m[1]);
        d.items.forEach(function (it) { ITEMS[it.id] = it; });
        st.items = more ? st.items.concat(d.items) : d.items;
        st.page = d.page; st.pages = d.pages; st.count = d.count; st.facets = d.filters || [];
        st.loading = false;
        if (key === active) renderPicker();
      })
      .catch(function () {
        if (seq !== st.seq) return;
        st.loading = false; st.error = true;
        if (key === active) renderPicker();
      });
  }

  /* Deck widths and wheel sizes come as exact values (83 deck widths at last count). Skaters shop in ranges, so
     those filters show ranges, and a range sends Shopify every exact value inside it. */
  var BANDS = {
    'filter.p.m.custom.deck_width': [[0, 7.999, 'Under 8\u2033'], [8, 8.249, '8\u20138.2\u2033'], [8.25, 8.499, '8.25\u20138.4\u2033'],
                                     [8.5, 8.749, '8.5\u20138.7\u2033'], [8.75, 8.999, '8.75\u20138.9\u2033'], [9, 99, '9\u2033 and up']],
    'filter.p.m.custom.wheel_diameter': [[0, 52.9, 'Up to 52mm'], [53, 54.9, '53\u201354mm'], [55, 56.9, '55\u201356mm'],
                                         [57, 59.9, '57\u201359mm'], [60, 999, '60mm and up']],
    'filter.p.m.custom.wheel_hardness': [[0, 90.9, 'Soft (up to 90A)'], [91, 96.9, '91\u201396A'], [97, 99.9, '97\u201399A'],
                                         [100, 999, '100A and up']]
  };
  function num(v) { var m = String(v).match(/\d+(?:\.\d+)?/); return m ? parseFloat(m[0]) : NaN; }
  function bandValues(param, f, band) {
    return (f.values || []).filter(function (v) {
      var n = num(v.value);
      if (param === 'filter.p.m.custom.wheel_hardness' && /b$/i.test(v.value)) return false;  // B scale is its own thing
      return n >= band[0] && n <= band[1];
    }).map(function (v) { return v.value; });
  }

  // Product names and descriptions go into HTML and attributes; many contain inch marks (8.25").
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function money(n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  }

  function deckWidth() {
    var d = picked.deck;
    if (!d) return null;
    if (d.width) return parseFloat(d.width);
    var m = String(d.name).match(/(?:^|[^\d.])(\d{1,2}\.\d{1,3})(?![\d.])/g) || [];
    for (var i = 0; i < m.length; i++) {
      var w = parseFloat(m[i].replace(/^[^\d]/, ''));
      if (w >= 6.5 && w <= 10.6) return w;          // a deck width, not a length like 31.85
    }
    return null;
  }

  function recommendedAxle() {
    var w = deckWidth();
    if (w === null) return null;
    var bands = window.C2C_BANDS || [];
    for (var i = 0; i < bands.length; i++) {
      if (w >= bands[i][0] && w < bands[i][1]) return bands[i][2];
    }
    return null;
  }

  function required() {
    return slots.filter(function (s) { return s.required; });
  }

  function total() {
    var t = 0, keys = Object.keys(picked);
    for (var i = 0; i < keys.length; i++) t += parseFloat(picked[keys[i]].price);
    return t;
  }

  function complete() {
    return required().every(function (s) { return picked[s.key]; });
  }

  function renderSlots() {
    var row = document.getElementById('slots');
    row.innerHTML = slots.map(function (s, i) {
      var p = picked[s.key];
      var inner = p
        ? '<span class="slot__img">' + (p.img
            ? '<img src="' + shot(p.img) + '" alt="" loading="lazy" decoding="async">'
            : '<span class="slot__ico">' + (s.icon || '') + '</span>') + '</span>' +
          '<span class="slot__name">' + esc(p.name) + '</span>' +
          '<span class="slot__price">' + money(p.price) + '</span>' +
          '<button class="slot__change" data-slot="' + s.key + '">Change</button>'
        : '<span class="slot__img"><span class="slot__ico">' + (s.icon || '') + '</span></span>' +
          '<span class="slot__name slot__name--empty">' + s.label +
            (s.required ? '' : ' <em>optional</em>') + '</span>' +
          '<button class="slot__add" data-slot="' + s.key + '">+ Choose</button>';
      return '<div class="slot' + (p ? ' is-set' : '') +
             (s.key === active ? ' is-active' : '') + '" data-slot="' + s.key + '">' +
             inner + '</div>';
    }).join('');
  }

  function filterBar(key, st) {
    var out = [], label = slotOf(key).label.toLowerCase();
    st.facets.forEach(function (f) {
      if (HIDE_FILTERS[f.param]) return;
      var chosen = st.picks[f.param] || [];
      if (f.type === 'price_range') {
        var top = Math.ceil((f.range_max || 0) / 100), opts = [25, 50, 75, 100, 150, 200].filter(function (x) { return x < top; });
        if (!opts.length) return;
        out.push('<label class="pf__sel"><span>' + esc(f.label) + '</span><select data-pfprice="' + key + '">' +
          '<option value="">Any</option>' + opts.map(function (x) {
            return '<option value="' + x + '"' + (String(st.maxPrice) === String(x) ? ' selected' : '') + '>Under $' + x + '</option>';
          }).join('') + '</select></label>');
        return;
      }
      var vals = (f.values || []).filter(function (v) { return v.count > 0 || chosen.indexOf(v.value) > -1; });
      if (vals.length < 2 && !chosen.length) return;
      var bands = BANDS[f.param];
      if (bands) {
        var chips = bands.map(function (b, i) {
          var inBand = bandValues(f.param, f, b), n = 0;
          (f.values || []).forEach(function (v) { if (inBand.indexOf(v.value) > -1) n += v.count; });
          var on = inBand.length && inBand.every(function (v) { return chosen.indexOf(v) > -1; }) && chosen.length === inBand.length;
          if (!n && !on) return '';
          return '<button class="pf__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-pfband="' + key +
                 '" data-param="' + esc(f.param) + '" data-band="' + i + '">' + b[2] + ' <em>' + n + '</em></button>';
        }).join('');
        if (chips) out.push('<div class="pf__row"><span class="pf__lab">' + esc(f.label) + '</span>' + chips + '</div>');
        return;
      }
      if (vals.length > 10) {
        out.push('<label class="pf__sel"><span>' + esc(f.label) + '</span><select data-pflist="' + key + '" data-param="' + esc(f.param) + '">' +
          '<option value="">All</option>' + vals.slice().sort(function (a, b) { return a.label.localeCompare(b.label); }).map(function (v) {
            return '<option value="' + esc(v.value) + '"' + (chosen.indexOf(v.value) > -1 ? ' selected' : '') + '>' +
                   esc(v.label) + ' (' + v.count + ')</option>';
          }).join('') + '</select></label>');
        return;
      }
      out.push('<div class="pf__row"><span class="pf__lab">' + esc(f.label) + '</span>' + vals.map(function (v) {
        var on = chosen.indexOf(v.value) > -1;
        return '<button class="pf__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + on + '" data-pfval="' + key +
               '" data-param="' + esc(f.param) + '" data-value="' + esc(v.value) + '">' + esc(v.label) + ' <em>' + v.count + '</em></button>';
      }).join('') + '</div>');
    });
    var any = Object.keys(st.picks).some(function (k) { return st.picks[k].length; }) || st.maxPrice;
    out.push('<label class="pf__sel"><span>Sort</span><select data-pfsort="' + key + '">' +
      [['', 'Featured'], ['price-ascending', 'Price, low to high'], ['price-descending', 'Price, high to low']].map(function (o) {
        return '<option value="' + o[0] + '"' + (st.sort === o[0] ? ' selected' : '') + '>' + o[1] + '</option>';
      }).join('') + '</select></label>');
    if (any) out.push('<button class="pf__clear" data-pfclear="' + key + '">Clear filters</button>');
    return '<div class="pf" aria-label="Filter ' + esc(label) + '">' + out.join('') + '</div>';
  }

  function card(s, p) {
    var on = picked[s.key] && picked[s.key].id === p.id;
    var shots = (p.imgs && p.imgs.length) ? p.imgs.length : (p.img ? 1 : 0);
    var qv = shots
      ? '<span class="qv" role="button" tabindex="0" data-qv="' + p.id +
        '" data-slot="' + s.key + '" title="Quick view"' +
        ' aria-label="Quick view: ' + esc(p.name) + '">' +
        MAG + (shots > 1 ? '<b class="qv__n">' + shots + '</b>' : '') + '</span>'
      : '';
    return '<button class="pick' + (on ? ' is-on' : '') + '" data-id="' + p.id +
      '" data-slot="' + s.key + '">' +
      '<span class="pick__m">' + (p.img ? '<img src="' + shot(p.img) + '" alt="" loading="lazy" decoding="async">' : '') +
      qv + '</span>' +
      '<span class="pick__n">' + esc(p.name) + '</span>' +
      '<span class="pick__p">' + money(p.price) + '</span>' +
      '<span class="pick__s' + (p.ships === 'later' ? ' is-later' : '') + '">' +
        (p.ships === 'later' ? 'Ships in 3\u20135 days' : 'In the shop') + '</span></button>';
  }

  function renderPicker() {
    var s = slotOf(active);
    var wrap = document.getElementById('picker');
    if (!s) { wrap.innerHTML = ''; return; }
    var st = step(active);
    if (st.count === null && !st.loading && !st.error) { load(active); return; }
    var axle = recommendedAxle();
    var note = '';
    if (s.key === 'trucks' && axle) {
      note = '<p class="picker__note">Your ' + deckWidth().toFixed(2) +
             '″ deck suits <strong>' + axle + '</strong> trucks. ' +
             'Anything else still works — this is what we’d put on it.</p>';
    }
    var head = '<div class="picker"><h3>Choose your ' + s.label.toLowerCase() + '</h3>' + note;
    if (st.error) {
      wrap.innerHTML = head + '<p class="picker__empty">These parts didn’t load. ' +
        '<button class="pf__clear" data-pfretry="' + s.key + '">Try again</button></p></div>';
      return;
    }
    if (st.count === null) {
      wrap.innerHTML = head + '<p class="picker__empty pf__loading" role="status">Loading ' + s.label.toLowerCase() + '\u2026</p></div>';
      return;
    }
    var filtered = Object.keys(st.picks).some(function (k) { return st.picks[k].length; }) || st.maxPrice;
    if (!st.count && !filtered) {
      wrap.innerHTML = head + '<p class="picker__empty">Out of stock right now. Leave it off and we’ll ' +
        'sort it when you collect, or call the shop on (309) 590-7588.</p></div>';
      return;
    }
    var shown = st.items.length;
    wrap.innerHTML = head + filterBar(s.key, st) +
      '<p class="pf__count" role="status">' + (st.count ? st.count.toLocaleString() + ' ' +
        (st.count === 1 ? 'choice' : 'choices') : 'Nothing matches these filters.') + '</p>' +
      (st.count ? '<div class="picker__grid">' + st.items.map(function (p) { return card(s, p); }).join('') + '</div>' : '') +
      (st.count && (st.page < st.pages || shown > 0)
        ? '<button class="btn pf__more" data-pfmore="' + s.key + '"' + (st.loading ? ' disabled' : '') + '>' +
          (st.loading ? 'Loading\u2026' : 'Show more') + '</button>'
        : '') + '</div>';
    showRows();
  }

  // Shows the first st.rows rows of the grid, however many columns it has at this width, and says how many of
  // the total that is. Hides "Show more" once every part is on screen.
  function showRows() {
    var st = step(active), grid = document.querySelector('#picker .picker__grid'), btn = document.querySelector('#picker .pf__more');
    if (!grid) return;
    var cols = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    var limit = cols * st.rows, cards = grid.children, shown = 0;
    for (var i = 0; i < cards.length; i++) { cards[i].hidden = i >= limit; if (i < limit) shown++; }
    if (!btn) return;
    btn.hidden = !(cards.length > limit || st.page < st.pages);
    if (!st.loading) btn.textContent = 'Show more (' + shown.toLocaleString() + ' of ' + st.count.toLocaleString() + ')';
  }
  var rowsTimer;
  addEventListener('resize', function () { clearTimeout(rowsTimer); rowsTimer = setTimeout(showRows, 120); });

  function renderSummary() {
    var t = total();
    var done = complete();
    var missing = required().filter(function (s) { return !picked[s.key]; })
                            .map(function (s) { return s.label; });
    document.getElementById('sum').innerHTML =
      '<p class="sum__total"><span>Total</span><b>' + money(t) + '</b></p>' +
      (done
        ? '<p class="sum__ship">' + (t >= 99
            ? 'Ships free — you’re over $99.'
            : 'Add ' + money(99 - t) + ' for free shipping.') + '</p>'
        : '<p class="sum__need">Still to choose: ' + missing.join(', ') + '</p>') +
      (Object.keys(picked).some(function (k) { return picked[k].ships === 'later'; })
        ? '<p class="sum__ship">This build ships in 3 to 5 business days.</p>' : '') +
      '<p class="sum__err" id="sum-err" role="alert" style="color:#b31217;font-size:.85rem;line-height:1.45;margin:.7rem 0 0" hidden></p>' +
      '<button class="btn btn--wide sum__add"' + (done ? '' : ' disabled') + '>' +
        (done ? 'Add complete to bag' : 'Finish your build') + '</button>' +
      '<button class="sum__reset">Reset build</button>';
  }

  var active = 'deck';
  function draw() { renderSlots(); renderPicker(); renderSummary(); }

  /* ---------------------------------------------------------------- quick view
     One product, full size, arrow through the shots. Arrows and counter only
     appear when there is genuinely more than one photo - showing a disabled
     arrow on a single-image product is a promise the catalogue cannot keep.  */
  var LB = { open: false, shots: [], i: 0, from: null };

  function lbEl() {
    var el = document.getElementById('lb');
    if (!el) {
      el = document.createElement('div');
      el.id = 'lb';
      el.className = 'lb';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.hidden = true;
      document.body.appendChild(el);
    }
    return el;
  }

  /* The spec rows, built only from fields the shop has actually filled in.
     Width leaves the grid card - it is noise beside a price - but it is the
     one number that decides which trucks fit, so it leads here and it also
     still drives the recommendation on the trucks step. */
  function detailRows(it) {
    var rows = [];
    if (it.width) rows.push(['Deck width', it.width + '\u2033']);
    if (it.opt)   rows.push(['Option', it.opt]);
    if (it.brand) rows.push(['Brand', it.brand]);
    if (it.kind)  rows.push(['Type', it.kind]);
    if (it.sku)   rows.push(['SKU', it.sku]);
    return rows;
  }

  function detailHtml() {
    var rows = detailRows(LB.item), desc = LB.item.desc || '';
    if (!rows.length && !desc) return '';
    var table = rows.length
      ? '<dl class="lb__specs">' + rows.map(function (r) {
          return '<dt>' + r[0] + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('') + '</dl>'
      : '';
    return '<div class="lb__det">' +
      '<button class="lb__dtog" data-lbdet aria-expanded="' + (LB.det ? 'true' : 'false') +
        '" aria-controls="lbdetp">Product details' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
        'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M6 9l6 6 6-6"/></svg></button>' +
      '<div class="lb__dpanel" id="lbdetp"' + (LB.det ? '' : ' hidden') + '>' +
        table + (desc ? '<p class="lb__desc">' + esc(desc) + '</p>' : '') +
      '</div></div>';
  }

  function lbDraw() {
    var el = lbEl(), n = LB.shots.length, multi = n > 1;
    el.innerHTML =
      '<div class="lb__scrim" data-lbclose></div>' +
      '<div class="lb__box" role="document">' +
        '<button class="lb__x" data-lbclose aria-label="Close quick view">&times;</button>' +
        '<figure class="lb__fig">' +
          '<img class="lb__img" src="' + big(LB.shots[LB.i]) + '" alt="' + esc(LB.name) +
          '" decoding="sync" fetchpriority="high">' +
        '</figure>' +
        (multi ? '<button class="lb__nav lb__nav--p" data-lbstep="-1" ' +
                 'aria-label="Previous photo">&#8249;</button>' +
                 '<button class="lb__nav lb__nav--n" data-lbstep="1" ' +
                 'aria-label="Next photo">&#8250;</button>' : '') +
        '<div class="lb__bar">' +
          '<span class="lb__t">' + esc(LB.name) + '</span>' +
          '<span class="lb__p">' + money(LB.price) + '</span>' +
          (multi ? '<span class="lb__c">' + (LB.i + 1) + ' / ' + n + '</span>' : '') +
          '<button class="btn lb__use" data-lbuse>' +
            (LB.picked ? 'Remove from build' : 'Use this ' + LB.label.toLowerCase()) +
          '</button>' +
        '</div>' +
        detailHtml() +
        (multi ? '<div class="lb__dots">' + LB.shots.map(function (u, k) {
            return '<button class="lb__dot' + (k === LB.i ? ' is-on' : '') +
                   '" data-lbgo="' + k + '" aria-label="Photo ' + (k + 1) + '"></button>';
          }).join('') + '</div>' : '') +
      '</div>';
    var x = el.querySelector('.lb__x');
    if (x) x.focus();
  }

  function lbOpen(slot, id, from) {
    var s = slotOf(slot);
    var item = ITEMS[id];
    if (!s || !item) return;
    LB.shots = (item.imgs && item.imgs.length) ? item.imgs : (item.img ? [item.img] : []);
    if (!LB.shots.length) return;
    LB.i = 0; LB.open = true; LB.from = from || null;
    LB.name = item.name; LB.price = item.price; LB.slot = slot; LB.id = item.id;
    LB.item = item; LB.det = false;
    LB.label = s.label;
    LB.picked = !!(picked[slot] && picked[slot].id === item.id);
    LB.shots.forEach(function (u) { var im = new Image(); im.src = shot(u); });
    var el = lbEl();
    el.setAttribute('aria-label', 'Quick view: ' + item.name);   // setAttribute needs no escaping
    el.hidden = false;
    lockScroll();
    lbDraw();
  }

  function lbClose() {
    if (!LB.open) return;
    LB.open = false;
    lbEl().hidden = true;
    unlockScroll();
    if (LB.from && document.body.contains(LB.from)) LB.from.focus();
  }

  function lbStep(d) {
    if (!LB.open || LB.shots.length < 2) return;
    LB.i = (LB.i + d + LB.shots.length) % LB.shots.length;
    lbDraw();
  }

  document.addEventListener('keydown', function (e) {
    if (!LB.open) return;
    if (e.key === 'Escape') { e.preventDefault(); lbClose(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); lbStep(1); }
    else if (e.key === 'ArrowLeft')  { e.preventDefault(); lbStep(-1); }
  });

  // Swipe, for the phone. A short flick should not count as a drag.
  (function () {
    var x0 = null;
    document.addEventListener('touchstart', function (e) {
      if (LB.open) x0 = e.touches[0].clientX;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!LB.open || x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 45) lbStep(dx < 0 ? 1 : -1);
    }, { passive: true });
  })();

  function refilter(key) { load(key); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pfval],[data-pfband],[data-pfclear],[data-pfmore],[data-pfretry]');
    if (t) {
      e.preventDefault();
      var key = t.getAttribute('data-pfval') || t.getAttribute('data-pfband') || t.getAttribute('data-pfclear') ||
                t.getAttribute('data-pfmore') || t.getAttribute('data-pfretry');
      var st = step(key), param = t.getAttribute('data-param');
      if (t.hasAttribute('data-pfmore')) {
        st.rows += ROWS;
        var g = document.querySelector('#picker .picker__grid');
        var cols = g ? getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length || 1 : 1;
        if (cols * st.rows > st.items.length && st.page < st.pages) load(key, true); else showRows();
        return;
      }
      if (t.hasAttribute('data-pfretry')) { load(key); return; }
      if (t.hasAttribute('data-pfclear')) { st.picks = {}; st.maxPrice = ''; refilter(key); return; }
      if (t.hasAttribute('data-pfval')) {
        var v = t.getAttribute('data-value'), cur = st.picks[param] || [];
        st.picks[param] = cur.indexOf(v) > -1 ? cur.filter(function (x) { return x !== v; }) : cur.concat([v]);
      } else {
        var f = st.facets.filter(function (x) { return x.param === param; })[0];
        var vals = f ? bandValues(param, f, BANDS[param][parseInt(t.getAttribute('data-band'), 10)]) : [];
        var cur2 = st.picks[param] || [];
        var on = vals.length && vals.every(function (x) { return cur2.indexOf(x) > -1; }) && cur2.length === vals.length;
        st.picks[param] = on ? [] : vals;               // one range at a time, like the old width buttons
      }
      refilter(key);
      return;
    }
    // Quick view is checked FIRST and stops here. It sits inside the .pick
    // button, so without this a look would also be a purchase decision.
    var q = e.target.closest('[data-qv]');
    if (q) {
      e.preventDefault(); e.stopPropagation();
      lbOpen(q.getAttribute('data-slot'), q.getAttribute('data-qv'), q);
      return;
    }
    var dt = e.target.closest('[data-lbdet]');
    if (dt) {
      // The dialog is top-anchored in CSS, so this just opens downward.
      LB.det = !LB.det;
      document.getElementById('lbdetp').hidden = !LB.det;
      dt.setAttribute('aria-expanded', LB.det ? 'true' : 'false');
      return;
    }
    if (e.target.closest('[data-lbclose]')) { lbClose(); return; }
    var st = e.target.closest('[data-lbstep]');
    if (st) { lbStep(parseInt(st.getAttribute('data-lbstep'), 10)); return; }
    var go = e.target.closest('[data-lbgo]');
    if (go) { LB.i = parseInt(go.getAttribute('data-lbgo'), 10); lbDraw(); return; }
    if (e.target.closest('[data-lbuse]')) {
      var it = ITEMS[LB.id];
      if (picked[LB.slot] && picked[LB.slot].id === LB.id) delete picked[LB.slot];
      else picked[LB.slot] = it;
      var nx = slots.filter(function (x) { return !picked[x.key]; })[0];
      if (nx) active = nx.key;
      lbClose(); draw();
      return;
    }
    var b = e.target.closest('[data-slot]');
    if (b && (b.classList.contains('slot__add') || b.classList.contains('slot__change'))) {
      active = b.getAttribute('data-slot'); draw();
      document.getElementById('picker').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var p = e.target.closest('.pick');
    if (p) {
      var slot = p.getAttribute('data-slot'), id = p.getAttribute('data-id');
      var item = ITEMS[id];
      if (!item) return;
      if (picked[slot] && picked[slot].id === item.id) delete picked[slot];
      else picked[slot] = item;
      var next = slots.filter(function (x) { return !picked[x.key]; })[0];
      if (next) active = next.key;
      draw();
      return;
    }
    if (e.target.classList.contains('sum__reset')) { picked = {}; active = 'deck'; draw(); return; }

    if (e.target.classList.contains('sum__add') && !e.target.disabled) {
      var btn = e.target, err = document.getElementById('sum-err');
      btn.disabled = true; btn.textContent = 'Adding\u2026';
      if (err) err.hidden = true;
      /* One of each part. The shop sells trucks as a pair, wheels as a set of
         four and bearings as a set of eight, so one of each IS a complete board.
         Every line carries the same build label, so the order tells the shop
         these parts go together and should be assembled. */
      var code = Math.random().toString(36).slice(2, 6).toUpperCase();
      var label = 'Build Your Own Board #' + code;
      var items = Object.keys(picked).map(function (k) {
        return { id: picked[k].id, quantity: 1, properties: { 'Build': label } };
      });
      var fail = function (msg) {
        /* Shopify can add some parts and refuse others. Take back anything
           from THIS build that got in, so the bag never holds half a board. */
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var updates = {};
            cart.items.forEach(function (it) {
              if (it.properties && it.properties.Build === label) updates[it.key] = 0;
            });
            if (!Object.keys(updates).length) return;
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          })
          .catch(function () {})
          .then(function () {
            btn.disabled = false;
            btn.textContent = 'Add complete to bag';
            if (err) {
              err.textContent = msg || 'One of these parts just sold out, so nothing was added. ' +
                'Please pick another, or call the shop on (309) 590-7588.';
              err.hidden = false;
            }
          });
      };
      fetch(window.C2C_CART_ADD, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (r.ok) { window.location = window.C2C_CART_URL; return; }
        return r.json().catch(function () { return {}; }).then(function (b) {
          fail(b && b.description ? 'Nothing was added: ' + b.description +
            ' Please pick another part, or call the shop on (309) 590-7588.' : null);
        });
      }).catch(function () { fail(null); });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var q = e.target.closest && e.target.closest('[data-qv]');
    if (!q) return;
    e.preventDefault(); e.stopPropagation();
    lbOpen(q.getAttribute('data-slot'), q.getAttribute('data-qv'), q);
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.matches) return;
    if (t.matches('[data-pfsort]')) { var st = step(t.getAttribute('data-pfsort')); st.sort = t.value; refilter(t.getAttribute('data-pfsort')); }
    else if (t.matches('[data-pfprice]')) { var st2 = step(t.getAttribute('data-pfprice')); st2.maxPrice = t.value; refilter(t.getAttribute('data-pfprice')); }
    else if (t.matches('[data-pflist]')) {
      var st3 = step(t.getAttribute('data-pflist'));
      st3.picks[t.getAttribute('data-param')] = t.value ? [t.value] : [];
      refilter(t.getAttribute('data-pflist'));
    }
  });

  function start() {
    draw();
    // The other steps load quietly after the first, so moving on to trucks or wheels is instant.
    setTimeout(function () { slots.forEach(function (s) { if (s.key !== active) load(s.key); }); }, 1200);
  }
  // Inside another page (the homepage) the builder sits at the foot: start it as a visitor scrolls within
  // about two screens of it, so its parts never compete with the top of the page. On its own page: at once.
  var spot = document.getElementById('slots');
  if (window.C2C_BUILD_LAZY && spot && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      if (!es.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect(); start();
    }, { rootMargin: '1600px 0px' });
    io.observe(spot.closest('section') || spot);
  } else {
    start();
  }
})();

})();